import _ from 'lodash';

/**
 * Applies start case formatting to a string while preserving common separators.
 *
 * @param input The input string
 * @param separators Optional array of custom separators to preserve
 * @returns The formatted string with preserved separators
 */
export default function smartStartCase(
  input: string,
  separators = ['/', ',', '-', '|'],
): string {
  if (!input) return input;

  // Create a regex to split and capture separators
  const separatorRegex = new RegExp(
    `(${separators.map(_.escapeRegExp).join('|')})`,
    'g',
  );

  // Split while keeping the separators
  return input
    .split(separatorRegex)
    .map(part => (separators.includes(part) ? part : _.startCase(part)))
    .join('');
}
